export default __webpack_public_path__ + "static/media/insta.7e5790b7.png";